<script>
    import app from "../stores/app";
    import user from "../stores/user";
    import localTransfers from "../stores/localTransfers";
    import {LOCAL_STATUSES, LOCAL_TYPE} from "../lib/constants";
    import {getDate} from "../lib/lib";
    import {createEventDispatcher} from 'svelte/internal';
    import AppIcon from "../components/icons/AppIcon.svelte";

    // EDO
    // let today = '';

    const dispatch = createEventDispatcher();

    const onEdit = (local_id) => {
        if (user.canEditTransfers()) {
            dispatch("edit", local_id);
        } else {
            dispatch("view", local_id);
        }
    }

    const onDelete = (transfer) => {
        dispatch("delete", transfer);
    }

    // EDO
    // $: {
    //     today = getDate('d-m-y');
    // }
</script>

<div class="locals-grid">
    {#each $localTransfers.list as transfer}
        <div class="local-item status-{ transfer.status_id }" on:click="{ () => onEdit(transfer.id) }">
            <div class="item-heading border-bottom">
                <div class="title">
                    <div class="icon">
                        {#if transfer.type_id == LOCAL_TYPE.PREBOOKED}
                            <AppIcon icon="calendar" size="16"/>
                        {:else}
                            <AppIcon icon="clock" size="16" strokeWidth="2"/>
                        {/if}
                    </div>
                    <div class="status-color-{ transfer.status_id }">
                        { LOCAL_STATUSES[transfer.status_id] }
                    </div>
                </div>
                <div class="date">
                    { transfer.date } { transfer.time }
                    <div class="toggler" class:expanded={ transfer.expanded }
                         on:click|preventDefault|stopPropagation={ () => transfer.expanded = !transfer.expanded }>
                        <AppIcon icon="chevron-left" size="16" strokeWidth="2"/>
                    </div>
                </div>
            </div>
            {#if !transfer.expanded}
                <div class="item-row">
                    { transfer.pickup_name } → { transfer.drop_name }
                </div>
                {#if transfer.passengers > 0}
                    <div class="item-row text-gray pt-0">Pax: { transfer.passengers }</div>
                {/if}
            {:else}
                <div class="item-row border-bottom">
                    <div class="row">
                        <div class="col-6">
                            <div class="small">From</div>
                            { transfer.pickup_name }
                            {#if transfer.room_no}
                                <address class="text-gray">Room: { transfer.room_no }</address>
                            {:else if transfer.pickup_address}
                                <address>{ transfer.pickup_address}</address>
                            {/if}
                        </div>
                        <div class="col-6">
                            <div class="small">Destination</div>
                            { transfer.drop_name }
                            {#if transfer.drop_address}
                                <address>{ transfer.drop_address}</address>
                            {/if}
                        </div>
                    </div>
                </div>
                {#if transfer.passengers > 0}
                    <div class="item-row border-bottom">
                        Pax: { transfer.passengers }
                    </div>
                {/if}
                <div class="item-row border-bottom">
                    <div class="row">
                        <div class="col-6">
                            {#if transfer.price}
                                € { transfer.price }
                            {/if}
                        </div>
                        <div class="col-6 d-flex align-items-center">
                            {#if transfer.arrival_time}
                                <span class="text-gray"><AppIcon icon="clock" cssClass="me-1"/></span>
                                { transfer.arrival_time } min
                            {/if}
                        </div>
                    </div>
                </div>
                {#if transfer.transporter}
                    <div class="item-row">
                        { transfer.transporter.name }
                    </div>
                {:else if transfer.taxi || transfer.driver}
                    <div class="item-row">
                        <div class="row">
                            <div class="col-6">
                                {#if transfer.taxi}
                                    { transfer.taxi.taxi_number }/{ transfer.taxi.licence_no }
                                {/if}
                            </div>
                            <div class="col-6">
                                {#if transfer.driver}
                                    <div class="text-gray">{ transfer.driver.name }</div>
                                {/if}
                            </div>
                        </div>
                    </div>
                {/if}
            {/if}
        </div>
    {/each}
</div>

<style>
    .locals-grid .local-item {
        background: #fff;
        border: 1px solid var(--table-border-color);
        border-left-width: 5px;
        border-radius: 3px;
        margin-bottom: 20px;
    }

    .locals-grid .local-item .item-heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .locals-grid .local-item .item-heading .title {
        display: flex;
        align-items: center;
        font-weight: 500;
        padding: 10px;
    }

    .locals-grid .local-item .item-heading .title .icon {
        color: #90a4ae;
        margin-right: 5px;
    }

    .locals-grid .local-item .item-heading .date {
        display: flex;
        align-items: center;
    }

    .locals-grid .local-item .item-heading .date .toggler {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        transition: .2s all ease;
    }

    .locals-grid .local-item .item-heading .date .toggler.expanded {
        transform: rotate(-90deg);
    }

    .locals-grid .local-item .item-row {
        padding: 10px;
    }

    .locals-grid .border-bottom {
        border-bottom: 1px dotted var(--table-border-color) !important;
    }

    .locals-grid .local-item .small {
        /*color: #a3a3a3;*/
        font-size: 0.6rem;
        color: #999;
    }

    .locals-grid .local-item address {
        margin-bottom: 0;
    }

    /* ASSIGNED */
    .locals-grid .local-item.status-2 {
        border-left-color: var(--local-status-assigned-color);
    }

    .locals-grid .status-color-2 {
        color: var(--local-status-assigned-color);
    }

    /* ACCEPTED */
    .locals-grid .local-item.status-3 {
        border-left-color: var(--local-status-accepted-color);
    }

    .locals-grid .status-color-3 {
        color: var(--local-status-accepted-color);
    }

    /* REJECTED */
    .locals-grid .local-item.status-1 {
        border-left-color: var(--local-status-rejected-color);
    }

    .locals-grid .status-color-1 {
        font-weight: 500;
        color: var(--local-status-rejected-color);
    }

    /* IN_PROGRESS */
    .locals-grid .local-item.status-4 {
        border-left-color: var(--local-status-in-progress-color);
    }

    .locals-grid .status-color-4 {
        color: var(--local-status-in-progress-color);
    }

    /* COMPLETED */
    .locals-grid .local-item.status-5 {
        border-left-color: var(--local-status-completed-color);
    }

    .locals-grid .status-color-5 {
        color: var(--local-status-completed-color);
    }

    /* CANCELED */
    .locals-grid .local-item.status-6 {
        border-left-color: var(--local-status-canceled-color);
    }

    .locals-grid .status-color-6 {
        color: var(--local-status-canceled-color);
    }
</style>